import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Container, Table } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Imgix from 'react-imgix'
import TagManager from 'react-gtm-module'
import { ShimmerTable } from 'react-shimmer-effects'
import { useUserService } from '@abroad/components'
import { isCutomSMScreen } from '../../utils/utility'
import { FancyboxPopup, PageHeader } from '../common'
import API from '../../utils/API'
import LearningResourceEvent from '../../constants/events'

const QuestsLearningResourcesVideo = () => {
  const { questId } = useParams()
  const history = useHistory()
  const { user } = useUserService()
  const [isLoading, setIsLoading] = useState(true)
  const [videos, setVideos] = useState([])

  useEffect(() => {
    const getAllBlogCategories = async () => {
      try {
        const { data } = await API.quests.getQuestMedias(questId)
        if (data) {
          setVideos(data.videos || [])
          setIsLoading(false)
        } else {
          setVideos([])
          setIsLoading(false)
        }
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }

    getAllBlogCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questId])

  const shortText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const gtmVideoLearningResource = (videoId) => {
    //GTM code
    TagManager.dataLayer({
      dataLayer: {
        event: LearningResourceEvent.event.playLRVideo,
        eventProps: {
          category: LearningResourceEvent.category.playLRVideoCategory,
          action: 'User play learning resource audio',
          label: 'Play learning resource audio',
          value: `User play learning resource audio, videoId is ${videoId}, questId is ${questId}`,
          userId: user?._id,
        },
      },
    })
  }
  return (
    <>
      <Helmet>
        <title>{`Your Experiences | Abroad`}</title>
        <meta name='title' content={`Your Experiences | Abroad`}></meta>
        <meta property='og:title' content={`Your Experiences | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`Your Experiences | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/quests`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
      </Helmet>

      <PageHeader
        showBackArrow={true}
        version='small'
        backArrowAction={() => history.goBack()}
        title={'Your Experiences'}
      />
      <h1 className='s1 py-16px'>Video</h1>

      {isLoading ? (
        <div className='mt-40px'>
          <ShimmerTable row={3} col={4} />
        </div>
      ) : videos.length === 0 ? (
        <h3 className='text-center s5'>
          There are no videos available at the moment. Please check back later!
        </h3>
      ) : (
        <Container fluid>
          <Table responsive className='custom-table align-middle table-hover'>
            <thead>
              <tr className='s10a border-dark'>
                {!isCutomSMScreen && <th width='5%'>#</th>}
                <th width={isCutomSMScreen ? '50%' : '40%'}>TITLE</th>
                <th width='50%'>DESCRIPTION</th>
                <th width='15%'>LENGTH</th>
              </tr>
            </thead>
            <tbody>
              {videos.map((videoMedia, index) => (
                <tr
                  key={index}
                  className='cursor-pointer'
                  onClick={() => {
                    FancyboxPopup(videoMedia.url)
                    gtmVideoLearningResource(videoMedia._id)
                  }}>
                  {!isCutomSMScreen && (
                    <td width='5%' className='hover:td-play-icon'>
                      <span>{index + 1}</span>
                      <span className='icon icon-play font-16 icon-outline-gold text-start'></span>
                    </td>
                  )}
                  <td width={isCutomSMScreen ? '50%' : '40%'}>
                    <div className='d-flex'>
                      <Imgix
                        className='border-radius-5'
                        imgixParams={{
                          crop: 'edges',
                          fit: 'crop',
                          w: 144,
                          h: 144,
                        }}
                        src={`${process.env.REACT_APP_IMG_SOURCE}/videos/${videoMedia.thumbnail}`}
                        height={window.innerWidth > 2000 ? 60 : 48}
                        width={window.innerWidth > 2000 ? 60 : 48}
                        alt='image'
                      />
                      <div className='ms-2 media-details d-flex flex-column w-100 align-self-center'>
                        <div className='d-flex'>{videoMedia.title}</div>
                      </div>
                    </div>
                  </td>
                  <td width='50%'>{shortText(videoMedia.description, 130)}</td>
                  <td width='15%'>{videoMedia.timeInMinute} Mins</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
      )}
    </>
  )
}

export default QuestsLearningResourcesVideo
